import Head from "next/head";
import { wrapper } from "@/redux/Store";

import TermsAndCondition from "@/containers/StaticPages/Terms";
import { renderMetaData } from "@/utils";
const TermsAndConditionPage = () => {
  const metaData = {
    title: "Shyft terms and conditions",
    description: "Shyft terms and conditions",
  };

  const metaTags = renderMetaData(metaData);
  return (
    <>
      {metaTags}
      <main>
        <TermsAndCondition />
      </main>
    </>
  );
};

export default TermsAndConditionPage;

export const getStaticProps = wrapper.getStaticProps(() => async () => {
  return {
    props: {},
    revalidate: 60 * 60 * 24 * 15, // revalidate in 15 days
  };
});
